import React from 'react';
import { motion } from 'framer-motion';

function SegmentedControl({
  value,
  onChange,
  options = [],
  className = '',
  size = 'default',
  layoutId = 'ios-segment-pill',
  'aria-label': ariaLabel,
}) {
  const sizeClass = size === 'compact' ? 'ios-segmented-compact' : 'ios-segmented-default';

  return (
    <div
      className={`ios-segmented ${sizeClass} ${className}`.trim()}
      role="group"
      aria-label={ariaLabel}
    >
      {options.map((option) => {
        const active = value === option.value;
        return (
          <button
            key={String(option.value)}
            type="button"
            onClick={() => onChange(option.value)}
            aria-pressed={active}
            className={`ios-segment ${active ? 'ios-segment-active' : ''}`}
          >
            {active ? (
              <motion.span
                layoutId={layoutId}
                className="ios-segment-pill"
                transition={{ type: 'spring', stiffness: 420, damping: 32 }}
              />
            ) : null}
            <span className="ios-segment-label">{option.label}</span>
          </button>
        );
      })}
    </div>
  );
}

export default SegmentedControl;
